// WL Top Brand Section - Scroll Animation
class WlTopBrandEffects {
  constructor() {
    this.sections = document.querySelectorAll('.wl-top-brand');
    if (this.sections.length === 0) return;
    this.init();
  }

  init() {
    this.setupScrollAnimation();
  }

  setupScrollAnimation() {
    // セクション全体を監視するObserver
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const section = entry.target;
          
          // アニメーション対象要素を順番に取得
          const elements = [];
          const subTitle = section.querySelector('.wl-top-brand__sub-title');
          const mainTitle = section.querySelector('.wl-top-brand__title h2');
          const listItems = section.querySelectorAll('.wl-top-brand__list-item');
          
          // 存在する要素のみを順番に配列に追加
          if (subTitle) elements.push(subTitle);
          if (mainTitle) elements.push(mainTitle);
          // リストアイテムも順番に追加
          listItems.forEach(item => {
            elements.push(item);
          });
          
          // 順番にアニメーションを開始（600ms間隔）
          elements.forEach((element, index) => {
            const delay = index * 600;
            setTimeout(() => {
              element.classList.add('animate-in');
            }, delay);
          });

          // アニメーション開始後は監視を停止（再トリガーを防ぐ）
          sectionObserver.unobserve(section);
        }
      });
    }, {
      threshold: 0.1, // セクションの10%が表示されたら開始
      rootMargin: '-10% 0px' // セクションが画面の10%入ってから開始
    });

    // 各セクションを監視
    this.sections.forEach(section => {
      sectionObserver.observe(section);
    });
  }
}

// Initialize function
function initWlTopBrandEffects() {
  new WlTopBrandEffects();
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWlTopBrandEffects);
} else {
  initWlTopBrandEffects();
}

// Shopify theme editor support
document.addEventListener('shopify:section:load', initWlTopBrandEffects);
document.addEventListener('shopify:section:reorder', initWlTopBrandEffects);

